import React from "react";
import styled from "styled-components";

const SvgContainer = styled.svg`
  height: 1.2rem;
  color: ${(p) => p.color || p.theme.color.red};
`;

const CheckedSvg = (props) => (
  <SvgContainer xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" {...props}>
    <defs>
      {/* <linearGradient id="Gradient1">
  
        <stop stopColor="#469FEE" offset="100%" />
      </linearGradient> */}

      <style>
        {`.a{fill:currentColor;}
          .b{fill:currentColor;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}`}
      </style>
    </defs>
    {/* <title>ico_</title> */}
    <rect className="a" x="1" y="1" width="26" height="26" rx="4" fill="url(#Gradient1)" />
    <polyline className="b" points="8 14 13 18 20 10" />
  </SvgContainer>
);

export default CheckedSvg;
